import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import _ from 'lodash'

const state = {
  isLoading: false,
  chartDatas: [],
  category: [
    {
      code: 'questionnaire',
      label: 'จำนวนแบบสอบถาม',
      backgroundColor: '#e48710',
      hoverBackgroundColor: '#e48408',
    },
    {
      code: 'anwser',
      label: 'จำนวนผู้ตอบ',
      backgroundColor: '#66ad4e',
      hoverBackgroundColor: '#5cab42',
    }
  ],
  tatics: [],
  update_date: null,
  filters: {
    years: [],
    months: [],
    types: [
      { text: 'All', value: '' },
      {text: "E-Survey", value: "e-survey"},
      {text: "E-Form ", value: "e-form"}
    ]
  }
}

// getters
const getters = {
  isLoading: state => {
    return state.isLoading;
  },
  chartDatas: state => {
    const labels = _.map(_.keys(_.groupBy(state.chartDatas, 'month_year')), (data) => {
      return moment(data).lang('th').format('MMMM-YYYY')
    });

    const categoryGroup = _.groupBy(state.chartDatas, 'category');
    let dataset = [];

    _.each(categoryGroup, (i) => {
      let category = i[0];

      const monthYear = _.groupBy(i, 'month_year');
      let total = _.map(monthYear, (items) => {
        const total = _.sumBy(items, function (item) {
            return item.total;
        });
        return total;
      });

      let config = state.category.find(c => c.code === category.category)

      let newb = {
        label: config.label,
        backgroundColor: config.backgroundColor,
        hoverBackgroundColor: config.hoverBackgroundColor,
        data: total
      };

      dataset.push(newb);
    });

    return {
      labels: labels,
      datasets: dataset
    };
  },
  tableDatas: state => {
    const labels = _.map(_.keys(_.groupBy(state.chartDatas, 'month_year')), (data) => {
      return {
        text: moment(data).lang('th').format('MMM'),
        textFull: moment(data).lang('th').format('MMMM'),
        value: data
      }
    });

    const first = _.first(labels)
    const last = _.last(labels)

    const datasets = _.chain(state.chartDatas)
      .groupBy("type")
      .map((type, key) => { 
        const category = _.groupBy(type, 'category')
        return { type: key, datas: category}
      })
      .value();

    return {
      dateStart: first ? first.textFull : '',
      dateEnd: last ? last.textFull : '',
      labels: labels,
      datasets: datasets
    };
  },
  update_date: state => {
    return state.update_date
  },
  filters_years: state => {
    return state.filters.years
  },
  filters_months: state => {
    return state.filters.months
  },
  filters_types: state => {
    return state.filters.types
  }
}

// mutations
const mutations = {
  SET_LOADING (state, loading) {
    state.isLoading = loading
  },
  async SET_CHART_DATAS (state, datas) {
    state.chartDatas = datas
  },
  SET_UPDATE_DATE (state, update_date) {
    state.update_date = update_date
  },
  SET_FILTER_YEARS (state, years) {
    state.filters.years = years
  },
  SET_FILTER_MONTHS (state, months) {
    state.filters.months = [
      { text: 'All', value: '' },
      ...months
    ]
  }
}

// actions
const actions = {
  getChartDatas(context, payload) {
    context.commit('SET_LOADING', true)

    const params = {
      params: qs.parse(payload)
    };

    instance.get('survey-create/chartBarDataset', params)
      .then(response => {
        context.commit('SET_LOADING', false)
        context.commit('SET_CHART_DATAS', response.data)
      })
      .catch(error => {
        console.log(error.response, "[store/survey-create/chartBarDataset] errors under instant.get");
      })
  },
  getUpdateDate(context) {
    instance.get('survey-create/updated_date')
      .then(response => {
        context.commit('SET_UPDATE_DATE', response.data)
      })
      .catch(error => {
        console.log(error.response, "[store/survey-create/updated_date] errors under instant.get");
      })
  },
  getFilters(context) {
    instance.get('survey-create/filters')
      .then(response => {
        context.commit('SET_FILTER_YEARS', response.data.years)
        context.commit('SET_FILTER_MONTHS', response.data.months.reverse())
      })
      .catch(error => {
        console.log(error.response, "[store/survey-create/filters] errors under instant.get");
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}